<template>
    <a-modal title="Setting" :visible="show" @cancel="onCancel" :width="650" @ok="onOk">
        <a-tabs v-model="active">
            <a-tab-pane key="1" tab="Profile & Nickname">
                <a-form class="login-form">
                    <a-form-item class="mb-0 profile" label="Profile" :colon="false">
                        <a-upload
                            :file-list="fileList"
                            :headers="{appid: $APPCFG.appid}"
                            :action="$BASE_URL + '/api/api/upload'"
                            list-type="picture-card"
                            :maxCount="1"
                            @change="onChangeImg">
                            <div v-if="fileList.length < 1">
                                <a-icon type="plus"></a-icon>
                            </div>
                        </a-upload>
                    </a-form-item>

                    <a-form-item class="mb-10" label="Nickname" :colon="false">
                        <a-input v-model="nickName"></a-input>
                    </a-form-item>
                </a-form>
            </a-tab-pane>

            <a-tab-pane key="2" tab="Bind phone">
                <a-form class="login-form">
                    <a-form-item class="mb-10" label="Phone" :colon="false">
                        <a-input v-model="memberMobile">
                            <template slot="addonAfter">
                                <a-button type="primary" style="width: 100px;" @click="onSendSms" :disabled="isDisabled">{{isDisabled?'Resend('+currentTime+')':'send'}}</a-button>
                            </template>
                        </a-input>
                    </a-form-item>

                    <a-form-item class="mb-10" label="Verification code" :colon="false">
                        <a-input v-model="mobileVcode"></a-input>
                    </a-form-item>
                </a-form>
            </a-tab-pane>

            <a-tab-pane key="3" tab="Old password">
                <a-form class="login-form">
                    <a-form-item class="mb-10" label="Old password" :colon="false">
                        <a-input v-model="oldPassword" type="password"></a-input>
                    </a-form-item>

                    <a-form-item class="mb-10" label="New password" :colon="false">
                        <a-input v-model="newPassword" type="password"></a-input>
                    </a-form-item>

                    <a-form-item class="mb-10" label="New password again" :colon="false">
                        <a-input v-model="againPassword" type="password"></a-input>
                    </a-form-item>
                </a-form>
            </a-tab-pane>
        </a-tabs>
    </a-modal>
</template>

<script>

    export default {
        props: {
            show: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                active: '1',
                fileList: [],
                // 修改昵称
                nickName: '',
                // 绑定手机号
                timer: '',
                isDisabled: false,
                currentTime: 60,
                memberMobile: '',
                mobileVcode: '',
                mobileToken: '',
                // 修改密码
                oldPassword: '',
                newPassword: '',
                againPassword: ''
            }
        },

        created() {
            
        },

        methods: {
            onChangeImg({ fileList }) {
                this.fileList = fileList;
            },
            // 修改昵称头像
            onChangeProfile(){
				if (this.fileList.length == 0){
					this.$message.error("Please upload your profile picture!");
					return
				}
				let params = {
					member_img: this.fileList[0].name == 'member_wx_avatar' ? this.fileList[0].url : this.fileList[0].response.src,
					member_name: this.nickName,
				}
				this.$HTTP.post('/member/member/edit_member_info',params ).then(({data}) => {
					if (data.sts == 1) {
						this.$message.success(data.msg,1).then(() => {
                            this.onCancel();
                        });
					} else {
						this.$message.error(data.msg);
					}
				})
			},
            // 获取验证码
            onSendSms(){
				let params = {
					mobile: this.memberMobile,
					mobile_area: 'au',
					type: 'reg',
				}
				this.$HTTP.post(`/member/index/sms_mobile`,params).then(res => {
					if(res.data.sts == 1) {
						this.$message.success(res.data.msg)
						this.mobileToken = res.data.data.token;
						this.isDisabled = true;
						clearInterval(this.timer);
						this.timer = setInterval(() => {
							if(this.currentTime == 0) {
								clearInterval(this.timer);
								this.isDisabled = false;
								this.currentTime = 60;
								return
							}else {
								this.currentTime --;
							}
						},1000)
					}else {
						this.$message.error(res.data.msg);
					}
				})
			},
            // 绑定手机号
            onBindPhone() {
                let params = {
					mobile: this.memberMobile,
					mobile_vcode: this.mobileVcode,
					mobile_token: this.mobileToken,
					mobile_ex: 'au',
					type: 'sapp',
				}
				this.$HTTP.post(`/member/member/edit_mobile`,params).then(({data}) => {
					if(data.sts == 1) {
						this.$message.success(data.msg).then(() => {
                            this.onCancel();
                        });
					}else {
						this.$message.error(data.msg);
					}
				})
            },

            // 修改密码
            onChangePassword() {
                let params = {
				    old_password: this.oldPassword,
				    password1: this.newPassword,
				    password2: this.againPassword,
				}
				this.$HTTP.post('/member/member/forget_password', params).then(({data}) => {
				    if (data.sts == 1) {
				        this.$message.success(data.msg,1).then(() => {
                            this.onCancel();
                        });
				    } else {
				        this.$message.error(data.msg);
				    }
				})
            },

            onOk() {
                if(this.active == '1') {
                    this.onChangeProfile();
                }else if(this.active == '2') {
                    this.onBindPhone();
                }else if(this.active == '3') {
                    this.onChangePassword();
                }
            },
            onCancel() {
                this.$emit('close')
				this.$store.dispatch('getInfo');
                Object.assign(this.$data,this.$options.data());
            }
        },
        watch: {
            show: {
                handler(n,o) {
                    if(n) {
                        this.fileList.push({
                            uid: -parseInt(Math.random()*100),
                            name: 'member_wx_avatar',
                            status: 'done',
                            url: this.$store.state.memberInfo.member_wx_avatar.split('!')[0]
                        })
                        this.nickName = this.$store.state.memberInfo.member_name;
                        this.memberMobile = this.$store.state.memberInfo.member_mobile;
                    }
                },
                deep: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .login-form {
        height: 240px;
    }
    /deep/.ant-form-item-label {
        line-height: normal;
    }

    /deep/ .ant-input-group-addon {
        padding: 0;
        border: none;
        .ant-btn {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
        }
    }

    .profile {
        /deep/ .ant-form-item-control {
            line-height: normal;
        }
    }
    
</style>